var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProctoringStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9499 25.5378C32.5871 27.4937 36.2703 30.6844 33.478 33.4766C30.6858 36.2689 27.495 32.5857 25.5391 27.9486L27.9499 25.5378Z",
    fill: "#3A484A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5753 23.5988C26.7717 22.7952 25.2302 23.0337 24.1323 24.1316C23.0345 25.2294 22.796 26.7709 23.5996 27.5745C24.4032 28.3781 25.9447 28.1396 27.0425 27.0417C28.1404 25.9439 28.3789 24.4024 27.5753 23.5988Z",
    fill: "#FFB357"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9744 28.3952C24.1768 28.3952 28.3942 24.1778 28.3942 18.9754C28.3942 13.773 24.1768 9.55566 18.9744 9.55566C13.7721 9.55566 9.55469 13.773 9.55469 18.9754C9.55469 24.1778 13.7721 28.3952 18.9744 28.3952Z",
    fill: "#FFCE71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9756 25.4569C22.5552 25.4569 25.4571 22.555 25.4571 18.9754C25.4571 15.3958 22.5552 12.4939 18.9756 12.4939C15.396 12.4939 12.4941 15.3958 12.4941 18.9754C12.4941 22.555 15.396 25.4569 18.9756 25.4569Z",
    fill: "#42C3E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8997 22.7883C13.3927 20.2563 13.3927 16.151 15.8997 13.619C16.1914 13.3244 16.505 13.0655 16.834 12.8395C15.9354 13.1494 15.0911 13.6655 14.3744 14.3893C11.8674 16.9213 11.8674 21.0266 14.3744 23.5586C16.5897 25.796 20.0205 26.0549 22.5188 24.3382C20.2744 25.1125 17.6901 24.5965 15.8997 22.7883Z",
    fill: "#00A5C7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "#CDCDCD",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProctoringStep);
export default __webpack_public_path__ + "static/media/proctoring_step.19ad01d5093eb1e6a78815b7e28e2e09.svg";
export { ForwardRef as ReactComponent };